export default {
  data: () => ({
    interval: null
  }),
  mounted() {
    if (this.pageVisit) {
      this.pageVisit(0);
      let time = 0
      this.interval = setInterval(() => {
        time++
        if (time == 5) {
          this.pageVisit(5);
        }
        if (time == 30) {
          this.pageVisit(30);
          clearInterval(this.interval)
        }
      }, 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}